/**
 * 登录响应字段工具（固定字段直取版）
 * 只读取：
 * - EndOfDay
 * - Now
 * - Token
 */

const pickFirstPositiveNumber = (source, keys) => {
    for (const key of keys) {
        const parsed = toPositiveNumber(source?.[key]);
        if (parsed !== null) {
            return parsed;
        }
    }
    return null;
};

const toPositiveNumber = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const extractTodayEndFromLoginResponse = (response) => {
    return pickFirstPositiveNumber(response, ['EndOfDay', 'endOfDay', 'endofday', 'today_end', 'todayEnd']);
};

export const extractServerNowFromLoginResponse = (response) => {
    return pickFirstPositiveNumber(response, ['Now', 'now', 'now_s', 'serverNow']);
};

export const extractGameTokenFromLoginResponse = (response) => {
    if (response?.Token === undefined || response?.Token === null) return null;
    const token = String(response.Token).trim();
    return token || null;
};

export const extractCrossDayTimePatch = (response) => {
    const todayEnd = extractTodayEndFromLoginResponse(response);
    const serverNow = extractServerNowFromLoginResponse(response);

    return {
        ...(todayEnd !== null ? { todayEnd, today_end: todayEnd } : {}),
        ...(serverNow !== null ? { serverNow, serverTimeOffsetMs: Date.now() - serverNow * 1000 } : {}),
    };
};
